import React from "react";
import { logger } from "../../lib/logging";
import { PrintIcon } from "../icons/PrintIcon.component";
const log = logger.getChild("PrintButton.component");

interface PrintButtonProps {
    height?: number;
    width?: number;
    callback?: () => void;
}

export const PrintButton = ({ callback }: PrintButtonProps) => {
    if (typeof window !== "undefined" && !window.print) {
        log.debug("window.print is not supported");
        return null;
    }

    const clickHandler = () => {
        window.print();
        callback?.();
    };

    return (
        <button
            data-platform="print"
            className="custom-button printer-button"
            aria-label="Print this page"
            onClick={clickHandler}
        >
            <PrintIcon />
        </button>
    );
};
